import { render, staticRenderFns } from "./PracticeDayWrong.vue?vue&type=template&id=10d64b76&scoped=true"
import script from "./PracticeDayWrong.vue?vue&type=script&lang=js"
export * from "./PracticeDayWrong.vue?vue&type=script&lang=js"
import style0 from "./PracticeDayWrong.vue?vue&type=style&index=0&id=10d64b76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d64b76",
  null
  
)

export default component.exports